<template>
  <li class="menu-subitem">
    <router-link :to="content.route" v-if="!content.children" @click.native="handleClick">
      <span>{{ content.text }}</span>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TheMenuSubitem',
  props: {
    content: {
      type: Object,
      required: true,
      validator: (value) => {
        return (value.route !== '' && value.text !== '')
      }
    }
  },
  components: {

  },
  methods: {
    ...mapActions({
      updateCurrentActive: 'header/updateCurrentActive'
    }),
    handleClick () {
      this.$emit('close')
      // this.updateCurrentActive(-1)
    }
  }
}
</script>

<style lang="scss">
  .menu-subitem{
    @include media("small-medium"){
      &:not(:last-of-type) > a{
        border-bottom: 1px solid shade(colors("foreground"), 10%);
      }
    }

    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 0 1 auto;

    > *{
      flex: 0 1 auto;
    }

    > a{
      @include text-color(colors("font"), colors("primary"));
      @include icon(icons("chevron-right"));
      @include media("small-medium"){
        padding: layout("spacing");

      }
      @include media("large"){
        padding: layout("spacing")*0.4;
      }

      display: block;
      font-size: 1.4rem;
      width: 100%;
      font-weight: font-weights("medium");
      line-height: 1;

      &::before{
        font-size: 1.2rem;
        margin-right: layout("spacing")/4;
      }
    }
  }
</style>
